<lazy-echart class="chart" [class.chart--fixed-height]="hasFixedHeight"
    [options]="options"
></lazy-echart>